var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGenderTumtum = function SvgGenderTumtum(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 25.3889C1.33594 20.729 5.11354 16.9514 9.77344 16.9514H11.6016C16.2615 16.9514 20.0391 20.729 20.0391 25.3889V34.1921C20.0391 35.59 18.9058 36.7233 17.5078 36.7233H3.86719C2.46922 36.7233 1.33594 35.59 1.33594 34.1921V25.3889Z",
    stroke: "#FF8C69",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 34.0514H12.6562C14.5202 34.0514 16.0312 32.5404 16.0312 30.6764V26.2538C16.0312 26.2072 15.9935 26.1694 15.9469 26.1694L13.2188 26.1694C11.8208 26.1694 10.6875 25.0362 10.6875 23.6382V21.0436C10.6875 20.997 10.6497 20.9593 10.6031 20.9593H7.875C6.47703 20.9593 5.34375 22.0925 5.34375 23.4905V30.6764C5.34375 32.5404 6.85479 34.0514 8.71875 34.0514Z",
    stroke: "#FF8C69",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.626 10.3512V14.0077C34.626 15.2769 34.0963 16.4884 33.1646 17.3502L30.2561 20.0406C29.9757 20.3 29.6076 20.4441 29.2255 20.4441H25.608C25.2259 20.4441 24.8579 20.3 24.5774 20.0406L21.669 17.3502C20.7373 16.4884 20.2076 15.2769 20.2076 14.0078V10.5315",
    stroke: "#FF8C69",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8235 3.74285L34.0251 2.54143C34.0251 2.54143 31.1323 1.2556 28.0175 1.33991C24.9027 1.42422 23.2113 3.14221 23.2113 3.14221C23.2113 3.14221 20.7399 1.94068 20.2075 5.54528C19.6609 8.11043 20.2076 11.553 20.2076 11.553C20.2076 11.553 21.5639 10.3682 22.1301 9.39022C22.792 8.24665 23.8121 6.74681 23.8121 6.74681C23.8121 6.74681 25.7022 7.77878 27.4166 7.94822C28.9688 8.10163 29.4841 6.96241 31.0212 7.22746C33.2485 7.61152 34.6261 11.553 34.6261 11.553L34.626 7.22746C34.626 5.49725 33.4643 4.10331 32.8235 3.74285Z",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9231 12.8251L8.9231 4.87345L13.8026 4.87345",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9231 12.8251L11.6712 10.077",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9231 12.8251L6.17502 10.077",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0554 26.2485L30.0554 34.2001L25.1759 34.2001",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0554 26.2485L27.3073 28.9965",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0554 26.2485L32.8035 28.9965",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderTumtum, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender_tumtum.26a57d94.svg";
export { ForwardRef as ReactComponent };